  <h1 mat-dialog-title class="col-12 p-0">
    <span class="w-100 h5 m-0">
      <span class="d-inline-block list-row-icon">
        <i class="rt-icon rt-certificate fs40 me-2"></i>
        {{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.TITLE' | translate }}
      </span>
    </span>
  </h1>
  <div mat-dialog-content cdkFocusRegionstart class="w-100 m-0 bg-white">
    <div class="row m-0" style="word-break: break-word;">

      <div class="col-12 col-md-6 col-xl-6 py-2">
        <mat-label class="w-100 d-block pb-3 mb-0 fw-bold">
          <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.ALIAS' | translate }} </span>
        </mat-label>
        <div class="w-100">
          <span *ngIf="certificate?.alias">
            {{certificate?.alias}}
          </span>
          <span class="text-danger d-inline-block" *ngIf="!certificate?.alias">
            {{'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-ALIAS' | translate}}
          </span>
        </div>
      </div>

      <div class="col-12 col-md-6 col-xl-6 py-2">
        <mat-label class="w-100 d-block pb-3 mb-0 fw-bold">
          <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.SUBJECT' | translate }} </span>
        </mat-label>
        <div class="w-100">
          <span *ngIf="certificate?.subject">
            {{certificate?.subject}}
          </span>
          <span class="text-danger d-inline-block" *ngIf="!certificate?.subject">
            {{'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-SUBJECT' | translate}}
          </span>
        </div>
      </div>

      <div class="col-12 col-md-6 col-xl-6 py-2">
        <mat-label class="w-100 d-block pb-3 mb-0 fw-bold">
          <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.ISSUER' | translate }} </span>
        </mat-label>
        <div class="w-100">
          <span *ngIf="certificate?.issuer">
            {{certificate?.issuer}}
          </span>
          <span class="text-danger d-inline-block" *ngIf="!certificate?.issuer">
            {{'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-ISSUER' | translate}}
          </span>
        </div>
      </div>

      <div class="col-12 col-md-6 col-xl-6 py-2">
        <mat-label class="w-100 d-block pb-3 mb-0 fw-bold">
          <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.EXPIRATION' | translate }} </span>
        </mat-label>
        <div class="w-100">
          <span *ngIf="certificate?.expiration">
            {{certificate?.expiration | dateMultiLang:currentLang}}
          </span>
          <span class="text-danger d-inline-block" *ngIf="!certificate?.expiration">
            {{'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-EXPIRATION' | translate}}
          </span>
        </div>
      </div>

      <div class="col-12 py-2">
        <mat-label class="w-100 d-block pb-3 mb-0 fw-bold">
          <span>{{ 'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.THUMBPRINT' | translate }} </span>
        </mat-label>
        <div class="w-100">
          <span *ngIf="certificate?.thumbprint">
            {{certificate?.thumbprint}}
          </span>
          <span class="text-danger d-inline-block" *ngIf="!certificate?.thumbprint">
            {{'WEB-SIGN.SIGNTRUST-LIB.CERTIFICATES-LIST.CARD.DETAILS.NO-THUMBPRINT' | translate}}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-stroked-button color="primary" class="ms-auto" [mat-dialog-close]="false">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'WEB-SIGN.SIGNTRUST-LIB.CLOSE' | translate }}</span>
    </button>
  </div>
